const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function initSignUpForms() {
    document.querySelectorAll('.newsletter-signup-form').forEach(initSignUpForm);
}

function initSignUpForm(form) {
    const emailInput = form.querySelector('input[type="email"]');
    const submitBtn = form.querySelector('button[type="submit"]');
    const inputRow = form.querySelector('.newsletter-input.input-group');
    const errorMsg = form.querySelector('.signup-error');
    const successMsg = form.querySelector('.signup-success');
    const recaptchaKey = form.dataset.recaptchaKey;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!EMAIL_REGEX.test(emailInput.value)) {
            showError('Please enter a valid email address.');
            return;
        }

        setLoading(true);

        let token = '';
        try {
            await waitForRecaptcha();
            token = await grecaptcha.execute(recaptchaKey, { action: 'signup' });
        } catch (err) {
            // reCAPTCHA unavailable (e.g. localhost) — server handles verification
        }

        const formData = new URLSearchParams(new FormData(form));
        formData.append('g-recaptcha-response', token);

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
            });

            const data = await response.json();

            if (data.result === 'success') {
                inputRow.style.display = 'none';
                errorMsg.style.display = 'none';
                successMsg.style.display = 'block';
            } else {
                showError(data.error || 'Something went wrong. Please try again.');
                setLoading(false);
            }
        } catch (err) {
            showError('Something went wrong. Please try again.');
            setLoading(false);
        }
    });

    function setLoading(loading) {
        submitBtn.disabled = loading;
        submitBtn.textContent = loading ? 'Sending...' : 'Request';
    }

    function showError(message) {
        errorMsg.textContent = message;
        errorMsg.style.display = 'block';
        successMsg.style.display = 'none';
    }
}

function waitForRecaptcha() {
    return new Promise((resolve, reject) => {
        if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
            resolve();
            return;
        }
        let attempts = 0;
        const interval = setInterval(() => {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                clearInterval(interval);
                resolve();
            } else if (++attempts > 20) {
                clearInterval(interval);
                reject(new Error('reCAPTCHA not loaded'));
            }
        }, 250);
    });
}
